/**
 * Module portal
 * @module app.portal
 */
define([
    'angular',
    'modules/portal/controllers/portalCtrl',
    'modules/portal/controllers/dashboardCtrl',
    'modules/portal/controllers/loginCtrl',
    'modules/portal/controllers/userCtrl',
    'modules/portal/controllers/userSectorCtrl',
    'modules/portal/controllers/rankingTaCtrl',
    'modules/portal/controllers/glpiProblemsCtrl',
    'modules/portal/controllers/modals/updateUserCtrl',
    'modules/portal/controllers/modals/updateSectorCtrl',
    'modules/portal/factories/authProvider',
    'modules/portal/factories/authService'
], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function portalHomeRouter($routeProvider) {
        $routeProvider.when('/portal', {
            templateUrl: 'portal/partials/portal.html',
            controller: 'PortalCtrl',
            controllerAs: 'portalCtrl',
            params: {
                menuTitle: 'Portail du BDC'
            }
        });

        $routeProvider.when('/login', {
            templateUrl: 'portal/partials/login.html',
            controller: 'LoginCtrl',
            controllerAs: 'loginCtrl',
            params: {
                menuTitle: 'Connexion'
            }
        });

        $routeProvider.when('/administration/users', {
            templateUrl: 'portal/partials/adminUser.html',
            controller: 'UserCtrl',
            controllerAs: 'userCtrl',
            params: {
                menuTitle: 'Administration des utilisateurs'
            }
        });

        $routeProvider.when('/administration/sectors', {
            templateUrl: 'portal/partials/adminSector.html',
            controller: 'UserSectorCtrl',
            controllerAs: 'userSectorCtrl',
            params: {
                menuTitle: 'Administration de la sectorisation'
            }
        });

        $routeProvider.when('/dashboard', {
            templateUrl: 'portal/partials/dashboard.html',
            controller: 'DashboardCtrl',
            controllerAs: 'DashboardCtrl',
            params: {
                menuTitle: 'Dashboard téléphonie'
            }
        });

        $routeProvider.when('/administration/ranking-ta', {
            templateUrl: 'portal/partials/rankingTa.html',
            controller: 'RankingTaCtrl',
            controllerAs: 'rankingTaCtrl',
            params: {
                menuTitle: 'Import fichiers csv'
            }
        });

        $routeProvider.when('/glpi-problems', {
            templateUrl: 'portal/partials/glpiProblems.html',
            controller: 'GlpiProblemsCtrl',
            controllerAs: 'glpiProblemsCtrl',
            params: {
                title: 'Problèmes GLPI'
            }
        });
    }

    portalHomeRouter.$inject = ['$routeProvider'];

    angular
        .module('app.portal', [
            'app.portal.portalCtrl',
            'app.portal.dashboardCtrl',
            'app.portal.loginCtrl',
            'app.portal.userCtrl',
            'app.portal.rankingTaCtrl',
            'app.portal.userSectorCtrl',
            'app.portal.glpiProblemsCtrl',
            'app.portal.updateUserCtrl',
            'app.portal.updateSectorCtrl',
            'app.portal.authProvider',
            'app.portal.authService'
        ])
        .config(portalHomeRouter);
});
